import { program as aboutProgram } from "./programs/about.js";
import { program as dssSolutionsProgram } from "./programs/dss_solutions.js";
import { program as helpProgram } from "./programs/help.js";
import { program as contactProgram } from "./programs/contact.js";
import { program as run486Program } from "./programs/486.js";
import { program as stpsProgram } from "./programs/stps.js";

export const programs = [aboutProgram, dssSolutionsProgram, helpProgram, contactProgram, run486Program, stpsProgram];